import axios from "axios";
import TenantService from "./tenant-service";
import { Environment } from "@/utils/environment";
import { Tenants } from "@/constants/Tenants";

// Per-tenant production API hosts. Tenants not listed here fall back to the
// default production API host below (e.g. so cookies are set/read on the
// same site as the tenant's own domain).
const ProductionApiHostsByTenant: Record<string, string> = {
  [Tenants.Rewards4Racing]: "https://api.rewards4racing.com",
    [Tenants.Rewards4RacingIreland]: "https://api.rewards4racing.ie",
    [Tenants.Rewards4Golf]: "https://api.rewards4golf.com",
    [Tenants.Rewards4RugbyLeague]: "https://api.rewards4rugbyleague.com"
};

const DefaultProductionApiHost = "https://api-rewards4platform.rewards4sport.com";

let baseUrl: string;
let tenantName: string = TenantService.getTenantName();

switch (true) {
  case Environment.isDevelopment:
    baseUrl = `https://localhost:7150/api/${tenantName}`;
    break;
  case Environment.isTest:
    baseUrl = `https://test-api-rewards4platform.rewards4sport.com/api/${tenantName}`;
    break;
  case Environment.isStaging:
    baseUrl = `https://staging-api-rewards4platform.rewards4sport.com/api/${tenantName}`;
    break;
  default: {
    const productionApiHost =
      ProductionApiHostsByTenant[tenantName] ?? DefaultProductionApiHost;
    baseUrl = `${productionApiHost}/api/${tenantName}`;
    break;
  }
}

const api = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    if (error.response?.status === 401) {
      window.location.href = "/signin";
    } else if (
      error.response?.status === 400 &&
      error.response?.data?.error === "Tenant Required"
    ) {
      console.error("[Axios] Tenant required error:", error.response.data);
      alert("Tenant configuration error. Please contact support.");
    }else if (
      error.response?.status === 404
    ) {
      window.location.href = "/errors/Error404";
    }

    const skipGlobal500Handler = !!error.config?.skipGlobal500Handler;

    if (error.response?.status >= 500 && !skipGlobal500Handler) {
      if (!location.pathname.startsWith("/errors")) {
        window.location.href = "/errors/Error500";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
